export default "__VITE_ASSET__BKgfbCmK__"